module.exports = __webpack_public_path__ + "img/thailand.2017261c.svg";